// Labeled input with optional error text. Shared across all auth forms.

import type { InputHTMLAttributes } from "react";

import { cn } from "@/lib/utils";

export interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string | null;
  hint?: string;
}

export function Field({ label, error, hint, className, id, ...rest }: FieldProps) {
  const inputId = id ?? `field-${label.replace(/\s+/g, "-").toLowerCase()}`;
  return (
    <label htmlFor={inputId} className="block mb-4">
      <span className="block font-mono text-[10.5px] uppercase tracking-[0.6px] text-ink-faint mb-1.5">
        {label}
      </span>
      <input
        id={inputId}
        {...rest}
        aria-invalid={error ? "true" : undefined}
        className={cn(
          "w-full bg-paper-card text-ink",
          "border border-[rgba(60,50,40,0.12)] rounded-[12px]",
          "px-4 py-3 text-[15px] font-sans leading-[1.4]",
          "outline-none transition-colors",
          "focus:border-rame focus:shadow-[0_0_0_3px_rgba(184,98,58,0.12)]",
          "placeholder:text-ink-faint",
          error && "border-brick-danger",
          className,
        )}
      />
      {error ? (
        <span className="block mt-1.5 text-[12.5px] text-brick-danger">{error}</span>
      ) : hint ? (
        <span className="block mt-1.5 text-[12px] text-ink-faint">{hint}</span>
      ) : null}
    </label>
  );
}
